import { WHITE } from '../colors';
var highlightConfig = {
  type: 'offer',
  variant: 'under-card',
  config: {
    'under-card': {
      borderBottomLeftRadius: 'BORDER_RADIUS_15',
      borderBottomRightRadius: 'BORDER_RADIUS_15',
      borderWidth: 1,
      borderColor: WHITE
    },
    'on-card': {
      borderTopLeftRadius: 'BORDER_RADIUS_15',
      borderTopRightRadius: 'BORDER_RADIUS_15',
      borderWidth: 1,
      borderColor: WHITE
    },
    'in-card': {
      borderRadius: 'BORDER_RADIUS_32'
    }
  }
};
export default {
  light: highlightConfig,
  dark: highlightConfig,
  white: highlightConfig
};